import React from 'react';
import './WhyDifferent.css';
import teamImage from '../Assets/images/pexels-thisisengineering-3913025.jpg';

const WhyDifferent = () => {
  const differentiators = [
    {
      title: "Corporate Responsibility",
      desc: "Our goal is zero incidents and our commitment to safety and ethics is industry leading.",
      icon: "👍"
    },
    {
      title: "Experts with Team Spirit",
      desc: "Our multi-skilled team provides innovative, forward-thinking solutions with a shared vision.",
      icon: "👥"
    },
    {
      title: "Diversity, Equity & Inclusion",
      desc: "We work with both investors and developers to create landmarks that make a lasting impact.",
      icon: "🌐"
    }
  ];

  return (
    <section className="different-section">
      <div className="different-container">
        {/* Left Side: Visuals */}
        <div className="different-visuals">
          <div className="main-image-wrapper">
            <img 
              src={teamImage}
              alt="Team collaborating" 
              className="team-img"
            />
            {/* Floating Rating Card */}
            <div className="rating-card">
              <div className="rating-score">4.9</div>
              <div className="rating-stars">★★★★★</div>
              <p className="rating-text">2k+ satisfied customers</p>
              <div className="customer-avatars">
                <div className="avatar"></div>
                <div className="avatar"></div>
                <div className="avatar"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Content */}
        <div className="different-content">
          <span className="small-tag">WHY CHOOSE US</span>
          <h2 className="section-title">What makes us <br/> different</h2>
          <p className="section-intro">
            It's not just about creating something good; it's about designing, 
            innovating, and collaborating to forge remarkable and unparalleled experiences.
          </p>

          <div className="diff-list">
            {differentiators.map((item, index) => (
              <div key={index} className="diff-item">
                <div className="diff-icon-box">{item.icon}</div>
                <div className="diff-text">
                  <h4 className="diff-item-title">{item.title}</h4>
                  <p className="diff-item-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDifferent;
